
<mat-form-field style="width:100%">
  <mat-label>{{ field.templateOptions.label }}</mat-label>
  <ngx-mat-file-input [formControl]="formControl">
  </ngx-mat-file-input>
</mat-form-field>
